module.exports = __webpack_public_path__ + "media/images/countrysquared/fj-ad3027c5a46563964bb953af00693bab.svg";